import React from 'react';
import "./register.css"   // ممكن تعدل الاسم أو تستخدم نفس الملف مع تعديلات CSS

function Register() {
  return (
    <div className="register">
      <h4>Create Account</h4>
      <h5>Sign up to get started</h5>

      <form className="register-form">
        {/* الاسم الأول (اختياري لكن شائع جدًا) */}
        <div className="mb-3">
          <label htmlFor="firstName" className="form-label">
            First Name
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter your first name"
            id="firstName"
            required
          />
        </div>

        {/* الاسم الأخير (اختياري) */}
        <div className="mb-3">
          <label htmlFor="lastName" className="form-label">
            Last Name
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter your last name"
            id="lastName"
            required
          />
        </div>

        {/* الإيميل */}
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email address
          </label>
          <input
            type="email"
            className="form-control"
            placeholder="Enter your email"
            id="email"
            aria-describedby="emailHelp"
            required
          />
          <div id="emailHelp" className="form-text">
            We'll never share your email with anyone else.
          </div>
        </div>

        {/* كلمة المرور */}
        <div className="mb-3">
          <label htmlFor="password" className="form-label">
            Password
          </label>
          <input
            type="password"
            className="form-control"
            placeholder="Create a strong password"
            id="password"
            required
          />
        </div>

        {/* تأكيد كلمة المرور (مهم جدًا في صفحة التسجيل) */}
        <div className="mb-3">
          <label htmlFor="confirmPassword" className="form-label">
            Confirm Password
          </label>
          <input
            type="password"
            className="form-control"
            placeholder="Confirm your password"
            id="confirmPassword"
            required
          />
        </div>

        <div className="mb-3 form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="agreeTerms"
            required
          />
          <label className="form-check-label" htmlFor="agreeTerms">
            I agree to the <a href="#terms">Terms of Service</a> and <a href="#privacy">Privacy Policy</a>
          </label>
        </div>

        <button type="submit" className="btn btn-primary w-100">
          Create Account
        </button>
      </form>

      <div className="social-icons mt-4 text-center">
        <i className="fa-brands fa-facebook mx-2"></i>
        <i className="fa-brands fa-twitter mx-2"></i>
        <i className="fa-brands fa-github mx-2"></i>
      </div>

      <p className="text-center mt-3">
        Already have an account? <a href="/login">Sign In</a>
      </p>
    </div>
  );
}

export default Register;